import { render, staticRenderFns } from "./template.vue?vue&type=template&id=4ac99004&"
import script from "./template.vue?vue&type=script&lang=js&"
export * from "./template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ConstructorLayout: require('/home/smiley/3df/components/Constructor/ConstructorLayout.vue').default,SectionRegister: require('/home/smiley/3df/components/Section/SectionRegister/SectionRegister.vue').default})
